import styled from "styled-components";


export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0, 0.5);
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
    top: 0;
    .modal-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`